module.exports = __webpack_public_path__ + "static/4_2_recommendation_DA-be92e02ba42d1e70967a3cc934a422da.svg";